// extracted by mini-css-extract-plugin
export default {"logo":"TcQWMX3YQF3FEgFyqmUBVA=="};